"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ExclamationCircleOutline = {
  name: 'exclamation-circle',
  theme: 'outline',
  nameWithTheme: 'exclamation-circle-o',
  tag: 'svg',
  attrs: {
    xmlns: 'http://www.w3.org/2000/svg',
    class: 'icon',
    viewBox: '0 0 1024 1024'
  },
  children: [{
    tag: 'path',
    attrs: {
      d: 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    },
    children: []
  }, {
    tag: 'path',
    attrs: {
      d: 'M464 688a48 48 0 1 0 96 0 48 48 0 1 0-96 0zM488 576h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z'
    },
    children: []
  }]
};
exports.default = ExclamationCircleOutline;